// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"g7-z","refreshPageWarning":"h7-z","redirectMessageText":"i7-z"};